import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectDataType, PrimaryButton } from '@systemeio/ui';
import { SendingEmailTimeSelector } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/sending-email-time-selector';
import { WeekdaysSelector } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/weekdays-selector';
import React from 'react';
import TimeDelayPicker from 'shared/components/date-picker/time-delay-picker';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { Action, ActionType, State } from './store';
import { ActivateCampaignStepErrors } from './types';
export interface ActivateCampaignStepContentProps<Errors = {}> {
  state: State;
  dispatch: React.Dispatch<Action>;
  withConfirmButton?: boolean;
  isPreFetching?: boolean;
  className?: string;
  afterCampaignStepsNamesSelectOptions: FormSelectDataType<number | null>[] | undefined;
  isButtonDisabled: boolean;
  isActivationFetching: boolean;
  handleConfirm: () => Promise<void>;
  errors?: ActivateCampaignStepErrors<Errors>;
}
export const ActivateCampaignStepContent = t0 => {
  const $ = _c(15);
  const {
    state,
    dispatch,
    className,
    isPreFetching,
    afterCampaignStepsNamesSelectOptions,
    withConfirmButton,
    isButtonDisabled,
    isActivationFetching,
    handleConfirm,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== afterCampaignStepsNamesSelectOptions || $[1] !== className || $[2] !== dispatch || $[3] !== errors?.delayValue || $[4] !== errors?.excludedWeekdays || $[5] !== errors?.stepBefore || $[6] !== errors?.timeOfTheDay || $[7] !== handleConfirm || $[8] !== isActivationFetching || $[9] !== isButtonDisabled || $[10] !== isPreFetching || $[11] !== state || $[12] !== t || $[13] !== withConfirmButton) {
    t1 = !isPreFetching ? <form className={`m-auto flex max-w-fit flex-col gap-6 lg:gap-10 ${className || ""}`}><div className="flex flex-col gap-5"><FormSelect error={errors?.stepBefore} label={t("dashboard.campaign_step.activate.step_before.label")} placeholder={t("dashboard.campaign_step.activate.step_before.placeholder")} containerClassName="basis-full" data={afterCampaignStepsNamesSelectOptions} value={state.afterCampaignStepName || undefined} onChange={value => dispatch({
          type: ActionType.set_after_campaign_step_name,
          payload: value ?? null
        })} /><TimeDelayPicker error={errors?.delayValue} label={t("dashboard.campaign_step.activate.delay_before_sending_email.label")} selectedTimeType={state.chosenTimeDelay.selectedTimeType} selectedTimeValue={state.chosenTimeDelay.selectedTimeValue} onChange={(value_0, type) => dispatch({
          type: ActionType.set_chosen_time_delay,
          payload: {
            selectedTimeValue: value_0,
            selectedTimeType: type
          }
        })} /><SendingEmailTimeSelector time={state.chosenSendingEmailTime} dispatch={dispatch} error={errors?.timeOfTheDay} /><WeekdaysSelector weekdays={state.chosenWeekdays} dispatch={dispatch} error={errors?.excludedWeekdays} />{withConfirmButton && <div className="flex justify-center"><PrimaryButton isFetching={isActivationFetching} disabled={isButtonDisabled} width="large" onClick={e => {
            e.preventDefault();
            handleConfirm();
          }} type="submit">{t("global.activate")}</PrimaryButton></div>}</div></form> : <div className="flex animate-pulse flex-col gap-8"><div className="bg-skeleton-primary/40 h-10 rounded-sm text-transparent">.</div><div className="bg-skeleton-primary/40 h-10 rounded-sm text-transparent">.</div><div className="bg-skeleton-primary/40 h-10 rounded-sm text-transparent">.</div><div className="bg-skeleton-primary/40 h-10 rounded-sm text-transparent">.</div></div>;
    $[0] = afterCampaignStepsNamesSelectOptions;
    $[1] = className;
    $[2] = dispatch;
    $[3] = errors?.delayValue;
    $[4] = errors?.excludedWeekdays;
    $[5] = errors?.stepBefore;
    $[6] = errors?.timeOfTheDay;
    $[7] = handleConfirm;
    $[8] = isActivationFetching;
    $[9] = isButtonDisabled;
    $[10] = isPreFetching;
    $[11] = state;
    $[12] = t;
    $[13] = withConfirmButton;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};